import { defineAsyncComponent } from "vue";
export default [
  {
    name: "SelfStudyAttemptCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "SelfStudyAttemptEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "SelfStudyAttemptSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "section/:sectionId",
    props: true,
  },
  {
    name: "SelfStudyAttemptSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "section/:sectionId/end",
    props: true,
  },
  {
    name: "SelfStudyAttemptActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    name: "SelfStudyAttemptCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "SelfStudyAttemptConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    name: "SelfStudyAttemptPasscode",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonPasscode")),
    path: "passcode",
    props: true,
  },
  {
    path: "not-found",
    name: "SelfStudyAttemptNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
  {
    path: "unpublished",
    name: "SelfStudyAttemptUnpublishedPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonUnpublishedPage.vue"),
    ),
  },
];
